<!-- هدر -->

<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> تعیین سرویس دانش آموزان </span>

    </div>

</div>

<!-- نتایج -->

<main class="row gx-0 p-0 p-md-2 gy-2 gy-md-0 border-md border-2">

    <div class="mapContainer col-12 col-md-8 px-0 px-md-2">

        <div class="border border-2 rounded h-100">

            <div id="map" class="position-sticky w-100 h-100 ">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>
            
        </div>

    </div>

    <div class="col-12 col-md-4 d-flex flex-column p-1 border border-2">

        <!-- فیلتر مدرسه -->

        <!-- h-79  -->

        <!-- h-94 -->

        <div dir="rtl" class="col-12 p-1">

            <input name="selectedSchool" #school [placeholder]="school.value == '' && filteredSchools.length == 0 ? 'لطفا اندکی صبر کنید' : 'نام مدرسه را جستجو کنید' "  autocomplete="off" class="form-control mb-1" [(ngModel)]="searchT_School" (input)="filterSchool()" />

            <ul class="list-group border" style="max-height: 66vh;">
            
              <li class="list-group-item pointer d-flex align-items-center" *ngFor="let item of filteredSchools" (click)="checkbox.click()" > <input type="checkbox" #checkbox (change)="setCheckBox($event.target.checked,item)" [checked]="isSelected(item.iMobileDomain)" class="ms-1 me-2">
                
                <small> {{ item.strCombinedDescription | faNum }} </small>
            
              </li>

              <li class="list-group-item pointer" *ngIf="school.value != '' && filteredSchools.length == 0 " > موردی یافت نشد </li>

            </ul>

        </div>

        <span dir="rtl" class="px-3" *ngIf="iResult > 0" >
            
            <b class="text-danger">{{iResult | faNum}}</b>
            
            مورد یافت شد
        
        </span>

        <div class="col-12 p-0 p-md-1">

            <div dir="rtl" class="col-12 p-1">

                <!-- رادیو گروه اول -->

                <fieldset id="group1" class="border border-2 px-1 py-2 rounded d-flex align-items-center justify-content-between">

                    <div class="d-flex align-items-center">
                        <input type="radio" id="0" name="group1" [(ngModel)]="tiStatus" value="0">
                        <label for="0" class="me-1">همه</label>
                    </div>

                    <div class="d-flex align-items-center">
                        <input type="radio" id="1" name="group1" [(ngModel)]="tiStatus" value="1">
                        <label for="1" class="me-1"> دارای سرویس </label>
                    </div>

                    <div class="d-flex align-items-center" >
                        <input type="radio" id="2" name="group1" [(ngModel)]="tiStatus" value="2">
                        <label for="2" class="me-1"> بدون سرویس </label>
                    </div>

                </fieldset>

                <!-- رادیو گروه دوم -->

                <fieldset id="group2" class="mt-1 border border-2 px-1 py-2 rounded d-flex align-items-center justify-content-between">

                    <div class="d-flex align-items-center">
                        <input type="radio" id="0" name="group2" [(ngModel)]="tiGender" value="0">
                        <label for="0" class="me-1">همه</label>
                    </div>

                    <div class="d-flex align-items-center">
                        <input type="radio" id="2" name="group2" [(ngModel)]="tiGender" value="2">
                        <label for="2" class="me-1"> دختر </label>
                    </div>

                    <div class="d-flex align-items-center" >
                        <input type="radio" id="1" name="group2" [(ngModel)]="tiGender" value="1">
                        <label for="1" class="me-1"> پسر </label>
                    </div>

                </fieldset>

                <!-- جستجو -->

                <button class="mt-1 d-flex align-items-center justify-content-center btn btn-primary w-100" (click)="search_result()"> 

                    جستجو
                    
                </button>
                
                <!-- خوشه بندی هوشمند -->

                <button class="mt-1 d-flex align-items-center justify-content-center btn btn-success w-100" (click)="cluster_Modal()"> 

                    خوشه بندی هوشمند
                    
                </button>

            </div>

        </div>

    </div>

</main>

<!-- مدال -->

<div class="modal fade" id="detailModal" tabindex="-1" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title">{{ !bDetermination ? 'جزئیات دانش آموز' : 'تعیین راننده'  }}</h5>

                <button *ngIf="!bDetermination" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                <button *ngIf="bDetermination" (click)="backTo()" type="button" class="btn-close" aria-label="Close"></button>

            </div>

            <ng-container *ngIf="!bDetermination">

                <div class="text-center">

                    <img class="rounded-circle" width="150" height="150" src="{{studentData?.strAvatar != '' ? 'data:image/jpeg;base64,' +  studentData?.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}" alt="">
    
                </div>
    
                <div dir="rtl" class="row p-2 gx-2 gy-2">
    
                    <div class="col-12 col-md-4">
    
                        <label>نام</label>
    
                        <input type="text" [ngModel]="studentData?.strName" class="form-control">
    
                    </div>
    
                    <div class="col-12 col-md-4">
    
                        <label>نام خانوادگی</label>
    
                        <input type="text" [ngModel]="studentData?.strFamily" class="form-control">
    
                    </div>
    
                    <div class="col-12 col-md-4">
    
                        <label>جنسیت</label>
    
                        <input type="text" [ngModel]="studentData?.strSex_strSexComment" class="form-control">
    
                    </div>
    
                    <div class="col-12 col-md-4">
    
                        <label>شماره موبایل</label>
    
                        <input dir="ltr" type="text" [ngModel]="( studentData?.strMobile | faNum )" class="form-control">
    
                    </div>
    
                    <div class="col-12 col-md-4">
    
                        <label> کد ملی </label>
    
                        <input dir="ltr" type="text" [ngModel]="( studentData?.strNationalCode | faNum)" class="form-control">
    
                    </div>
    
                    <div class="col-12 col-md-4">
    
                        <label> نام راننده </label>
    
                        <input type="text" [ngModel]="studentData?.strFullName" class="form-control text-danger">
    
                    </div>
    
                    <div class="col-6">
    
                        <label>مدرسه</label>
    
                        <input type="text" [ngModel]="studentData?.strMobileDomain_strComment" class="form-control">
    
                    </div>
    
                    <div class="col-6">
    
                        <label>فاصله تا مدرسه</label>
    
                        <input type="text" [ngModel]="( studentData?.fDistance| faNum ) + ' کیلومتر' " class="form-control">
    
                    </div>
    
                    <div class="col-12">
    
                        <label> آدرس </label>
    
                        <input type="text" [ngModel]="studentData?.strAddress" class="form-control">
    
                    </div>
    
                    <div class="col-md-6 col-6">
    
                        <label>طول جغرافیایی</label>
    
                        <input dir="ltr" type="text" [ngModel]="( studentData?.fOriginLon | faNum )" class="form-control">
    
                    </div>
    
                    <div class="col-md-6 col-6">
    
                        <label>عرض جغرافیایی</label>
    
                        <input dir="ltr" type="text" [ngModel]="( studentData?.fOrigiLat| faNum )" class="form-control">
    
                    </div>
    
                </div>
    
                <div class="px-2 py-2">
    
                    <button class="btn btn-primary px-3 w-100" (click)="bDetermination = true"> تعیین راننده  </button>
                    
                </div>

            </ng-container>

            <ng-container *ngIf="bDetermination">

                <div *ngIf="!bDriverStd" dir="rtl" class=" col-12 p-1" >

                    <input name="selectedSchool" #driver [placeholder]="driver.value == '' && filteredSchools.length == 0 ? 'لطفا اندکی صبر کنید' : 'نام راننده را جستجو کنید' "  autocomplete="off" class="form-control mb-1 no-x" [(ngModel)]="searchD_School" (input)="filterDriver()" />
        
                    <ul class="list-group" style="max-height: 400px;overflow: auto;">
                    
                      <li class="list-group-item pointer d-flex align-items-center"  *ngFor="let item of filteredDrivers" (click)="selectedDriver(item)" > 
                        
                          {{ 'نام راننده : ' + item.strFullName  | faNum }} <br> {{ ' نوع خودرو : ' + item.strMobileType_strComment   | faNum }} <br>

                          {{'تعداد دانش آموز پسر : ' + item.iStudent_Boy | faNum }}  <br>  {{'تعداد دانش آموز دختر : ' + item.iStudent_Girl | faNum }}
                        
                      </li>
              
                    </ul>
        
                </div>

                <div *ngIf="bDriverStd" dir="rtl" class="border border-2 p-2" style="max-height: 400px;overflow: auto;">

                    <table *ngIf="list_Std4Drivers.length > 0" class="table table-striped" id="Export_Excel">
    
                        <thead class="position-sticky top-0 bg-white">
            
                            <tr class="col-12 text-center">

                                <th> # </th>

                                <th> حذف </th>

                                <th> نام و نام خانوادگی </th>

                                <th> جنسیت </th>

                                <th> مدرسه </th>

                                <th> فاصله تا مدرسه </th>


                            </tr>
            
                        </thead>
            
                        <tbody>
            
                            <tr class="col-12 text-center" *ngFor="let item of list_Std4Drivers;let i = index">
            
                                <th> {{ i + 1 | faNum }} </th>

                                <td><i class="fa fa-trash fa-lg text-danger pointer" aria-hidden="true" (click)="removeStd4Driver(item)"></i></td>

                                <td>{{item.strPassenger_FullName | faNum}}</td>

                                <td>{{item.strSex_strSexComment}}</td>

                                <td>{{item.strMobileDomain_strComment | faNum}}</td>

                                <td>{{ (item.fDistance | faNum ) + ' کیلومتر' }}</td>
            
                 
                            </tr>
            
                        </tbody>
            
                    </table>

                    <div *ngIf="list_Std4Drivers.length == 0 " class="p-2 text-center">

                        <p> این راننده هنوز دانش آموزی ندارد </p>

                    </div>

                    <div class="d-flex justify-content-end py-2">

                        <button class="btn btn-success px-2 w-100" (click)="determine_StdToDriver()"> {{ 'افزودن ' + studentData.strPassenger_FullName + ' به لیست دانش آموزان ' + searchD_School }} </button>
                        
                    </div>

                </div>

            </ng-container>

        </div>

    </div>

</div>

<!-- مدال خوشه بندی -->

<div class="modal fade" id="Modal_Clustering" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> خوشه بندی هوشمند </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Cluster" dir="rtl" class="row p-2 gx-2 gy-2">

                    <!-- تعداد دانش آموزان در هر خوشه -->
    
                    <div class="col-12">
    
                        <label> تعداد دانش آموزان در هر خوشه </label>
    
                        <input formControlName="tiPassengers" class="form-control text-end">
    
                    </div>

                    <!-- حداکثر فاصله دانش آموزان از همدیگر -->
    
                    <div class="col-12">
    
                        <label> حداکثر فاصله دانش آموزان از همدیگر(کیلومتر) </label>
    
                        <input formControlName="fMaxDistanceInKm" class="form-control text-end">
    
                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="search_Cluster()">

                    &nbsp; جستجو &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- لودینگ -->

<ng-container *ngIf="isLoading" class="">

    <div class="school_loading">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>